import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getLedgers, getStockInward, updateLedgers } from "api";
import moment from "moment/moment";

// Table data

class FactoryWiseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      ledgerList: [],
      paymentStatus: "Pending",
      props: props,
    };
  }

  async componentDidMount() {
    this.getStockList();
  }
  async getStockList() {
    const data = await getStockInward({
      page: this.state.page,
      limit: this.state.sizePerPage,
      paymentStatus:this.state.paymentStatus
    });
    if(data && data.data){
      this.setState({
        totalSize: data.data.count,
        ledgerList: data.data.jangads,
      });
    }
   
  }
  async update() {
    const data = await updateLedgers({
      id: this.state.props.data.id,
      approveStatus: this.state.approveStatus,
    });
  }

  render() {
    this.columns1 = [
      {
        dataField: "as",
        text: `#`,
        sort: true,
        isDummyField: true,
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.name;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return row.weight;
        },
      },
      
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "salesOfficeOutWardStock",
        text: `${this.props.t("OutWard Date")}`,
        formatter(cell, row) {
          if(cell == null) return "-"
          else 
          return moment(cell.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "mainJangd",
        text: `${this.props.t("Payment Status")}`,
        sort: true,
        formatter: (cell, row) => {
          console.log(row.ledgerDetail);
          if (row.mainJangad.ledgerDetail == null) {
            return <></>;
          } else
          if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Paid") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Paid
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Refund") {
            return (
              <button className="btn-danger-red border-0 py-2 px-3 rounded">
                Refund
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "PartialPaid") {
            return (
              <button className="btn-primary-blue border-0 py-2 px-3 rounded">
                Partial Paid
              </button>
            );
          }
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/party-wise-stock-view",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    const { history } = this.props;

    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.ledgerList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.ledgerList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("TRANSACTIONS")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Transaction List")}
                                </h3>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      Search
                                    </label>
                                    <select
                                      id="factoryId"
                                      className="officestock-select"
                                    >
                                      <option value="xyz-party">
                                        XYZ Diamond
                                      </option>
                                      <option value="xyz-party">
                                        abc Diamond
                                      </option>
                                      <option value="xyz-party">
                                        XYZ Diamond
                                      </option>
                                      <option value="xyz-party">
                                        abc Diamond
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>
                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Ledger ID")}
                                    </label>
                                    <select
                                      id="ledgerID"
                                      className="officestock-select"
                                    >
                                      <option value="1">LEDGER0000321</option>
                                      <option value="2">LEDGER0000322</option>
                                      <option value="3">LEDGER0000323</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Payment Status")}
                                    </label>
                                    <select
                                      id="factoryId"
                                      className="officestock-select"
                                      value={this.state.paymentStatus}
                                      onChange={(e) => {
                                        this.setState({paymentStatus:e.target.value},() => {
                                          this.getStockList();
                                        })
                                      }}
                                    >
                                    
                                      <option value="All">All</option>
                                      <option value="Paid">Paid</option>
                                      <option value="Pending">Pending</option>
                                      <option value="Refund">Refund</option>
                                      <option value="Partial Paid">
                                        Partial Paid
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    onTableChange={() => false}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                      <div className="">
                        <h5>
                          {this.props.t("Showing")}{" "}
                          {(this.state.page - 1) * this.state.sizePerPage + 1} -{" "}
                          {this.state.totalSize < this.state.sizePerPage
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page >=
                              this.state.totalSize
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page}{" "}
                          of {this.state.totalSize}
                        </h5>
                      </div>
                      <div className="ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(FactoryWiseReport);
